export default __webpack_public_path__ + "static/media/034-grapes.1aabf2d0.svg";